import React, { useEffect, useState } from 'react';
import LoadingBox from "../../components/LoadingBox";
import { VesselService } from "../../util/services/vessel";
import { showErrorResponse } from "../../util/varibles/global";
import List from "./List";


const EquipmentsPage: React.FC = () => {
    const [{ loading, equipments }, setEquipments] = useState<{ loading: boolean, equipments: any[] }>({
        loading: false,
        equipments: []
    });
    useEffect(() => {
        setEquipments(prev => ({ ...prev, loading: true }));
        VesselService.equipments()
            .then(rs => setEquipments({ loading: false, equipments: rs }))
            .catch(error => {
                setEquipments(prev => ({ ...prev, loading: false }));
                showErrorResponse('Get data failed', error)
            });
    }, []);

    return <div className='m-header bgPage'>
        <div className='header-page'>
            <div className='title-page'>
                <b>Equipment Management</b>
            </div>
        </div>
        <div className='body-page' data-box='true'>
            {equipments.length === 0 && <LoadingBox loading={loading} />}
            <List data={equipments} />
        </div>
    </div>;
};

export default EquipmentsPage;
